export default class Before {
  static BASE64 = "iVBORw0KGgoAAAANSUhEUgAAAAEAAAAGCAIAAACNcmNmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAATSURBVBhXY3A3aWJiYGBAxQwMABYTAQhk4ShuAAAAAElFTkSuQmCC";
}


// WEBPACK FOOTER //
// ./resource/base64/before.jsx